import { render, staticRenderFns } from "./saleinvoicedetailview.vue?vue&type=template&id=7fcdc634&scoped=true&"
import script from "./saleinvoicedetailview.vue?vue&type=script&lang=js&"
export * from "./saleinvoicedetailview.vue?vue&type=script&lang=js&"
import style0 from "./saleinvoicedetailview.vue?vue&type=style&index=0&id=7fcdc634&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fcdc634",
  null
  
)

export default component.exports